import 'react';
import { Text } from 'reaxl';
import CalculatorInput from './CalculatorInput.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function TradeInfoInputs(_ref) {
  let {
    digitalRetailingType,
    disabled,
    icoValue,
    supportingLinks = {},
    valueOwed,
    valueTradeIn,
    ...rest
  } = _ref;
  const {
    kbbLink,
    payoffQuoteLink
  } = supportingLinks;
  if (disabled) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Text, {
      className: "display-none display-sm-block margin-bottom-4",
      size: 300,
      weight: "bold",
      children: "Trade-In"
    }), /*#__PURE__*/jsx(CalculatorInput, {
      name: "tradeInInput",
      label: "Est. Trade-In Value",
      value: valueTradeIn,
      supportingLink: kbbLink,
      ...rest
    }), /*#__PURE__*/jsx(CalculatorInput, {
      name: "amountOwedInput",
      label: "Amount Owed on Trade-In",
      value: valueOwed,
      supportingLink: payoffQuoteLink,
      ...rest
    })]
  });
}
export { TradeInfoInputs as default };
